export default __webpack_public_path__ + "static/media/vission.10df459e.svg";